module.exports = __webpack_public_path__ + "static/media/icon_linkedin.78fda1da.svg";